import { connect } from "react-redux";
import { useState, useEffect } from "react";
import { merge } from "lodash";
import { addMonths, format } from "date-fns";

import Select from "react-select";
import NotificationManager from "react-notifications/lib/NotificationManager";
import JournalConditions from "./JournalConditions";

import { Actions as ACCOUNTINGACTIONS } from "../../../store/actions/accountingActions";
import { Actions as EMPLOYEEACTIONS } from "../../../store/actions/employeeActions";
import {CheckCircleIcon, TrashIcon, ExclamationCircleIcon, PlusCircleIcon} from "@heroicons/react/20/solid";
import {groupBy} from "lodash";
import { v4 as uuidv4 } from "uuid";

/* Arrays that contain the expenses and liabilities that will be shown
   in case of variations later on */
const expenses = ["Gross Wages", "Employer NIC", "Employer Pension"];
const liabilities = ["Net Wages", "PAYE", "NIC", "Student Loan", "Pensions", "Apprenticeship Levy", "Other Deductions"];

const Journals = ({
	costCenterLevelOptions,
	costCenterOptionsPerLevel,
	expensesGLOptions,
	liabilitiesGLOptions,
	flatGLOptions,
	save,
	dirty,
	saveConditions,
	journalConditions,
	employeesGetListWithSalary,
	orgId,
	journalsLevels,
	setSelectedLevels,
}) => {
	const selectedLevels = journalsLevels || {};
	// const [selectedLevels, setSelectedLevels] = useState({});

	// This is a check to ensure that employees are available if not fetch them
	const [fromDate, setFromDate] = useState(new Date(format(addMonths(new Date(), -2), "yyyy-MM-01")));
	const [toDate, setToDate] = useState(new Date(format(new Date(), "yyyy-12-31")));
	useEffect(() => {
		employeesGetListWithSalary({ from: format(fromDate, "yyyy-MM-dd"), to: format(toDate, "yyyy-MM-dd") });
	}, [orgId]);


	useEffect(() => {
		setSelectedLevels(journalsLevels);
	}, [selectedLevels]);

	const updateLevel = (field, level, value) => {
		if (!field) return;
		const newData = {...selectedLevels};

		if (!newData[field]) {
			newData[field] = {};
		}
		newData[field][level] = value;

		setSelectedLevels(newData);
		// save(newData);
	};

	const addCondition = () => {
		const newCondition = [...journalConditions];
		newCondition.push({
			id: uuidv4(),
		});
		saveConditions(newCondition);
	};

	const submitConditions = () => {
		for (const condition in journalConditions) {
			const currentCondition = journalConditions[condition];

			if (!currentCondition?.when || !currentCondition?.set) {
				NotificationManager.error("Fields cannot be left empty!", "Journal Conditions");
				return;
			}

			for (const condition in currentCondition.set) {
				if (condition == 0) continue;
				const option = currentCondition.set[condition];

				if (option?.type != currentCondition.set[0]?.type) {
					NotificationManager.error("And conditions under set cannot be left empty!", "Journal Conditions");
					return;
				}
			}
		}

		NotificationManager.success("Conditions saved successfully", "Journal Conditions");
		saveConditions(journalConditions);
	};

	return (
		<>
			<form className="form-grid col-12">
				<div className="form-section col-span-3 row-span 2">
					<div className="col-xs-3 pull-left form-container">
						<h4>Journals</h4>
					</div>
					<div className="col-xs-3 pull-right">
						<button
							className="btn btn-danger pull-right"
							type="button"
							onClick={() => {
								setSelectedLevels({});
								save({});
							}}
						>
							<TrashIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
							<span style={{ float: "left" }}>Clear Tables</span>
						</button>
					</div>
					<div className="col-xs-12 form-container form-material">
						<table className="table table-borderless">
							<thead style={{ background: "#ea611c", color: "#fff" }}>
								<tr>
									<th scope="col">Debits</th>
									<th scope="col">Accounting Category</th>
									{costCenterLevelOptions?.map((center) => {
										return <th scope="col">{`Lv ${center?.value}`}</th>;
									})}
								</tr>
							</thead>
							<tbody style={{ background: "#fff" }}>
								{expenses.map((expense) => {

									const selectedExpense = selectedLevels?.[expense]?.['GL'];
									return (
										<tr>
											<th
												scope="row"
												className="col-xs-1"
											>
												{expense}
											</th>
											<td className="col-xs-3">
												<Select
													name="EGL"
													options={expensesGLOptions}
													placeholder="Choose one"
													value={flatGLOptions.find(
														(i) => i.value == selectedExpense,
													)}
													onChange={(e) => {
														updateLevel(`${expense}`, 'GL', e?.value);
													}}
													className="col-xs-11"
												/>
											</td>
											{costCenterLevelOptions?.map((center) => {
												const levelSelection = selectedLevels?.[expense]?.[center?.value];
												console.log('levelSelection',levelSelection,center,selectedLevels?.[expense]?.[center?.value])
												return (
													<td className="col-xs-2">
														<Select
															name="EL"
															options={costCenterOptionsPerLevel.find(c => c.value == center.value)?.options}
															placeholder="Choose One"
															value={costCenterOptionsPerLevel.find(c => c.value == center.value)?.options?.find(
																(i) => i.value == levelSelection,
															)}
															onChange={(e) => {
																// let value = {};
																// value[center?.Code] = e?.value;
																updateLevel(`${expense}`, center?.value, e?.value);
															}}
														/>
													</td>
												);
											})}
										</tr>
									);
								})}
							</tbody>
						</table>
						<table className="table table-borderless">
							<thead style={{ background: "#ea611c", color: "#fff" }}>
								<tr>
									<th scope="col">Credits</th>
									<th scope="col">Accounting Category</th>
									{costCenterLevelOptions?.map((center) => {
										return <th scope="col">{`Lv ${center?.value}`}</th>;
									})}
								</tr>
							</thead>
							<tbody style={{ background: "#fff" }}>
								{liabilities.map((liability) => {

									const selectedLiability = selectedLevels?.[liability]?.['GL'];
									return (
										<tr>
											<th
												scope="row"
												className="col-xs-1"
											>
												{liability}
											</th>
											<td className="col-xs-3">
												<Select
													name="LGL"
													options={liabilitiesGLOptions}
													placeholder="Choose one"
													value={flatGLOptions.find(
														(i) => i.value == selectedLiability,
													)}
													onChange={(e) => {
														updateLevel(`${liability}`, 'GL', e?.value);
													}}
													className="col-xs-11"
												/>
											</td>
											{costCenterLevelOptions?.map((center) => {
												const levelSelection =
													selectedLevels[liability] &&
													selectedLevels[liability][center?.value];
												return (
													<td className="col-xs-2">
														<Select
															name="LL"
															options={costCenterOptionsPerLevel.find(c => c.value == center.value)?.options}
															placeholder="Choose One"
															value={costCenterOptionsPerLevel.find(c => c.value == center.value)?.options?.find(
																(i) => i.value == levelSelection,
															)}
															onChange={(e) => {
																updateLevel(`${liability}`, center?.value, e?.value);
															}}
														/>
													</td>
												);
											})}
										</tr>
									);
								})}
							</tbody>
						</table>
					</div>
					<div className="col-xs-3 pull-left">
						<h4>Rules</h4>
					</div>
					<div
						className="col-xs-3 pull-right"
						style={{ marginBottom: 10 }}
					>
						<button
							type="button"
							className="btn btn-success pull-right"
							onClick={() => addCondition()}
						>
							<PlusCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
							<span style={{ float: "left" }}>Add</span>
						</button>
					</div>
					<div
						className="col-xs-12"
						style={{ marginBottom: 25 }}
					>
						{journalConditions.map((condition, index) => {
							return (
								<JournalConditions
									data={condition}
									key={index}
									rowIndex={index}
								/>
							);
						})}
					</div>

					<div
						className="col-xs-2 pull-right"
						style={{ marginBottom: 10 }}
					>
						<button
							type="button"
							className="btn btn-success pull-right"
							onClick={() => save()}
						>
							{
								dirty ?
									<ExclamationCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
									:
									<CheckCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
							}
							<span style={{ float: "left" }}>
								{
									dirty ?
										"Save Changes"
										:
										"Saved"
								}
							</span>
						</button>
					</div>
				</div>
			</form>
		</>
	);
};

const mapStateToProps = (state) => {

	// given that the data is fed in via Redux this is a good place to manipulate the data before it is passed to the component

	const employees = state?.employees?.employeeListWithSalary || [];

	// map the employees to the format that the Select component expects
		// include the reference number in the label or idNo / NIC number
	const employeeOptions =
		employees?.map((employee) => (
			{
				label: `${employee?.employeeName} ${employee?.employeeSurname} (${employee?.reference ?? employee?.idNo ?? employee?.NIC})`,
				value: employee
			}
		));

	const departments = state?.company?.settings?.departments || [];

	const departmentOptions = departments.map((department) => ({ label: department?.name, value: department }));


	const ledgers = state?.accounting?.ledgers?.data || [];
	const costCenters = state?.accounting?.costCenters?.data || [];


	// group gl options by Type for use in react-select
	const glTypes = groupBy(ledgers, "type")
	const glOptions = Object.keys(glTypes).map((type) => {
		return {
			label: type,
			options: glTypes[type].map((gl) => ({ label: `${gl?.name} (${gl?.code})`, value: gl.code }))
		}
	})

	// TODO consider adding type filtering based on the type of ledger used [expenses, liabilities, etc]

	const expensesGLOptions = glOptions

	const liabilitiesGLOptions = glOptions

	// gl options are grouped; flatten them to easily select the GLs
	const flatGLOptions = glOptions.reduce((acc, curr) => {
		return acc.concat(curr.options);
	}, []);

	const costCenterLevels = groupBy(costCenters, "Level")
	const levelOptions = Object.keys(costCenterLevels).map((level) => {
		return {
			label: `Level ${level}`,
			value: level
		}
	})

	const costCenterOptionsPerLevel = Object.keys(costCenterLevels).map((level) => {
		return {
			label: `Level ${level}`,
			value: level,
			options: costCenterLevels[level].map((center) => ({ label: `${center?.name} (${center?.code})`, value: center?.code }))
		}
	})


	// const [expensesGLOptions, setExpensesGLOptions] = useState([]);
	// const [liabilitiesGLOptions, setLiabilitiesGLOptions] = useState([]);
	// const [levelOptions, setLevelOptions] = useState([]);
	// const [departmentOptions, setDepartmentOptions] = useState([]);

	let dirty = state?.accounting?.journals?.dirty ?? false;

	if (!dirty) {
		// check if any of the journalConditions is dirty
		dirty = state?.accounting?.journals?.conditions?.some(c => c.dirty) ?? false;
	}

	return {
		journalConditions: state?.accounting?.journals?.conditions || [],
		journalsLevels: state?.accounting?.journals?.selectedLevels || {},
		departmentOptions,
		costCenterLevelOptions: levelOptions,
		costCenterOptionsPerLevel,
		expensesGLOptions,
		liabilitiesGLOptions,
		flatGLOptions,
		employeeOptions,
		orgId: state?.company?.settings?.org,
		dirty,
	};
};

const mapDispatchToProps = (dispatch) => ({
	save: (selectedLevels) =>
		dispatch(ACCOUNTINGACTIONS.accountingSaveJournals(selectedLevels)),
	setSelectedLevels: (selectedLevels) =>
		dispatch(ACCOUNTINGACTIONS.accountingUpdateJournals(selectedLevels)),
	saveConditions: (data) => dispatch(ACCOUNTINGACTIONS.accountingSaveConditions(data)),
	employeesGetListWithSalary: ({ from, to }) =>
		dispatch(
			EMPLOYEEACTIONS.employeesGetListWithSalary(
				{
					from: from ? from : format(addMonths(new Date(), -2), "yyyy-MM-01"), // get list from last 2 months
					to: to ? to : format(new Date(), "yyyy-12-31"),
				},
				{ includeTax: true },
			),
		),
});

export default connect(mapStateToProps, mapDispatchToProps)(Journals);
